export default {"src":"/_next/static/media/tescoma-klub-karta-en.99272c64.svg","height":150,"width":237,"blurWidth":0,"blurHeight":0};